import React, { useEffect, useState } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import navbarimage from "assets/img/layout/Navbar.png";
import { useNavigate, useLocation } from "react-router-dom";
import { getNotifications, getNotificationLogs } from "services/notifications";
import { useAuthContext } from "../../hooks/AuthContext";
import { BsArrowBarUp } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";
import { backendOrigin } from "../../api";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const navigate = useNavigate();
  const { logout, user } = useAuthContext();
  const getPfpUrl = (pfp?: string) => {
    if (!pfp) return avatar;
    if (
      pfp.startsWith("http") ||
      pfp.startsWith("https") ||
      pfp.startsWith("/")
    )
      // If it's an absolute or root path, ensure it points to backend origin
      return pfp.startsWith("/") ? `${backendOrigin}${pfp}` : pfp;
    // otherwise pfp is a relative storage path like 'pfps/filename.jpg'
    return `${backendOrigin}/storage/${pfp}`;
  };
  const displayName =
    user?.name ||
    `${user?.firstname || ""} ${user?.lastname || ""}`.trim() ||
    "User";

  useEffect(() => {
    const load = async () => {
      setLoadingNotifications(true);
      try {
        const isAdmin = window.location.pathname.startsWith("/admin");
        const data = isAdmin
          ? await getNotificationLogs()
          : await getNotifications();
        // data may be { data: [...] } or an array
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : data || [];
        setNotifications(list as any[]);
      } catch (err) {
        console.error(err);
        setNotifications([]);
      } finally {
        setLoadingNotifications(false);
      }
    };
    load();
  }, []);

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                const q = searchValue.trim();
                if (q.length) navigate(`/search?q=${encodeURIComponent(q)}`);
              }
            }}
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white lg:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* Notifications dropdown */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex max-h-[420px] w-[360px] flex-col gap-3 overflow-y-auto rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notifications
                </p>
                <p className="text-sm font-medium text-navy-700 dark:text-white">
                  {loadingNotifications
                    ? "Loading..."
                    : `${notifications.length} recent`}
                </p>
              </div>
              {loadingNotifications ? (
                <div className="text-center text-sm text-gray-500">
                  Loading...
                </div>
              ) : notifications.length === 0 ? (
                <div className="text-center text-sm text-gray-500">
                  No notifications
                </div>
              ) : (
                notifications.map((n: any, i: number) => (
                  <button
                    key={i}
                    className="flex w-full items-start gap-3 rounded-lg p-2 text-left hover:bg-gray-50 dark:hover:bg-navy-600"
                  >
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-100 text-brand-600">
                      🔔
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-semibold text-gray-900 dark:text-white">
                        {n.title || n.type || "Notification"}
                      </div>
                      <div className="text-xs text-gray-600 dark:text-gray-300">
                        {n.body || n.message || ""}
                      </div>
                      <div className="mt-1 text-[11px] text-gray-400">
                        {n.created_at
                          ? new Date(n.created_at).toLocaleString()
                          : ""}
                      </div>
                    </div>
                  </button>
                ))
              )}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        {/* Info dropdown */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div
                style={{
                  backgroundImage: `url(${navbarimage})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <div className="flex flex-col items-center justify-center py-4">
                <span className="text-lg font-bold text-navy-700 dark:text-white">
                  NAC
                </span>
                <span className="text-xs text-gray-500 dark:text-gray-300">
                  Community Portal
                </span>
              </div>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
        />

        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>

        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={getPfpUrl(user?.pfp)}
              alt={displayName + " avatar"}
            />
          }
          children={
            <div className="flex h-48 w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="ml-4 mt-3">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {displayName}
                  </p>
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20 " />
              <div className="ml-4 mt-3 flex flex-col">
                <Link
                  to="/user/profile"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                <button
                  onClick={async () => {
                    try {
                      await logout();
                      navigate("/");
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  className="mt-3 text-left text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
